import { render } from "./WCToastRoot.vue?vue&type=template&id=550b5257&scoped=true"
import script from "./WCToastRoot.vue?vue&type=script&lang=js"
export * from "./WCToastRoot.vue?vue&type=script&lang=js"

import "./WCToastRoot.vue?vue&type=style&index=0&id=550b5257&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-550b5257"]])

export default __exports__